// このファイルは自動生成されます
export const LIB_VERSION = "v1.0.3.2";
